import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApprovedCammeler } from '../model/approved_cammeler_dto';
import { environment } from '../../environments/environment';
import { S3File } from '../model/S3_file_dto';
import { ObsProfileRequestDTO } from '../model/obs-profile-request-dto';
import { SERVICES_CONSTANTS } from '../utils/constants';
import { Observable } from 'rxjs';
import { StringUtils } from '../utils/stringUtils';

@Injectable({
  providedIn: 'root'
})
export class WorkbiesService {
  private baseUrl: string = environment.baseUrl;

  constructor(
    private http: HttpClient,
    private stringUtils: StringUtils
  ) {}

  getWorkbies(): Observable<any> {
    const url = this.stringUtils.buildUrl(
      this.baseUrl,
      SERVICES_CONSTANTS.ADMIN_PATH.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.MANAGEMENT_WORKBIES.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.MANAGEMENT_WORKBIES.GET_ALL_PENDING_WORKBIES
    );
    return this.http.get<any>(url);
  }

  approveWorkbi(body: ApprovedCammeler): Observable<any> {
    const url = this.stringUtils.buildUrl(
      this.baseUrl,
      SERVICES_CONSTANTS.ADMIN_PATH.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.MANAGEMENT_WORKBIES.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.MANAGEMENT_WORKBIES.APPROVE_WORKBI
    );
    return this.http.post<any>(url, body);
  }

  getS3File(body: S3File): Observable<any> {
    const url = this.stringUtils.buildUrl(
      this.baseUrl,
      SERVICES_CONSTANTS.ADMIN_PATH.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.MANAGEMENT_WORKBIES.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.MANAGEMENT_WORKBIES.GET_S3_FILE
    );
    return this.http.post<any>(url, body);
  }

  getStatusFiles(): Observable<any> {
    const url = this.stringUtils.buildUrl(
      this.baseUrl,
      SERVICES_CONSTANTS.ADMIN_PATH.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.STATUS.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.STATUS.STATUS_FILES
    );
    return this.http.get<any>(url);
  }

  saveObsData(body: ObsProfileRequestDTO): Observable<any> {
    const url = this.stringUtils.buildUrl(
      this.baseUrl,
      SERVICES_CONSTANTS.ADMIN_PATH.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.MANAGEMENT_WORKBIES.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.MANAGEMENT_WORKBIES.SAVE_OBS_PROFILE
    );
    return this.http.post<any>(url, body);
  }
}
